import styled from 'styled-components';
import {
  AA_LINK_ON_LIGHT,
  AA_TEXT_ON_LIGHT,
  AA_DISABLED_BG,
  AA_DISABLED_BORDER,
} from '~/modules/Helper/contrast.helper';

const GLYPH_SIZE = '14px';

/** Agrupa os botões e anula o line-height 64px do Header do Ant. */
export const AcessibilityBar = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  line-height: 0;
  overflow: visible;
  white-space: nowrap;

  > span {
    display: flex;
    line-height: 0;
    margin: 0;
    overflow: visible;
  }
`;

/** Conteúdo interno: texto e ícone no mesmo retângulo, centralizados. */
export const AcessibilityGlyph = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.05em;

  .anticon {
    display: flex !important;
    align-items: center;
    justify-content: center;
    width: ${GLYPH_SIZE};
    height: ${GLYPH_SIZE};
    margin: 0;
    padding: 0;
    font-size: ${GLYPH_SIZE};
    line-height: 0;
    vertical-align: 0;
  }

  .anticon svg {
    display: block;
    width: ${GLYPH_SIZE};
    height: ${GLYPH_SIZE};
  }
`;

/** Botão nativo do banner — evita padding/span do ant-btn e herança do Header. */
export const AcessibilityButton = styled.button`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  min-width: 28px;
  height: 28px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 6px;
  background-color: ${({ $bg }) => $bg || AA_LINK_ON_LIGHT};
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 0;
  cursor: pointer;
  overflow: visible;
  flex-shrink: 0;
  vertical-align: top;

  &:disabled {
    background-color: ${AA_DISABLED_BG};
    color: ${AA_TEXT_ON_LIGHT};
    border: 1px solid ${AA_DISABLED_BORDER};
    opacity: 1;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 2px;
  }
`;
